import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const linkPreviewConverter = {
  toPm: {
    types: [Node_Type.LINK_PREVIEW],
    // @ts-expect-error next node type
    convert: (node) => ({
      type: Node_Type.LINK_PREVIEW,
      attrs: {
        ...node.linkPreviewData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.LINK_PREVIEW],
    // @ts-expect-error next node type
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.LINK_PREVIEW,
        id,
        nodes: [],
        linkPreviewData: {
          ...data
        }
      };
    }
  }
};
export {
  linkPreviewConverter
};
//# sourceMappingURL=link-preview-converter.js.map
